export function formatPhone (value: string | undefined): string {
  return (value || '').split('').join(' ').replace(/([0-9]) ([0-9])\b/g, '$1$2');
}
